function Cookies() {
    const cookiesEnabled = navigator.cookieEnabled;

    return (
        <div className="information_card">
            <h3>Cookie status</h3>
            <p className="information" data-cookie-status={cookiesEnabled ? 'Enabled' : 'Disabled'}>{cookiesEnabled ? (
                "Enabled"
            ) : (
                "Disabled"
            )}</p>
        </div>
    );
}

export default Cookies;